import { defineMessages } from "react-intl";

export const messages = defineMessages({
  subtitle: {
    id: "v2+u4c",
    defaultMessage:
      "Assign and sort warehouses that will be used in this channel (warehouses can be assigned in multiple channels).",
    description: "card subtitle",
  },
});
